<template>
  <span class="label-text">{{ label }}</span>
  <div v-if="showLoading">
    <Skeleton width="100%" height="1.5rem" />
  </div>
  <div v-else>
    <div class="fs-5" v-if="value" v-html="sanitizeHTML(value)"></div>
    <div class="fs-5" v-else>-</div>
  </div>
</template>

<script setup>
import Skeleton from 'primevue/skeleton';
import { sanitizeHTML } from '@/utils/pageUtils';
defineProps({
    label: {
        type: String,
        default: ''
    },
    value: {
        type: String,
        default: ''
    },
    showLoading: {
        type: Boolean,
        default: false
    }
});
</script>